import { Box } from "@mui/material";
import React from "react";
import { useIntl } from "react-intl";

// icon component
// chart / pie / table / map / wordCloud

// wording component
// later / range

// size component
// small / medium / large

export default function EmptyIconStatus({
  icon = "chart",
  wording = "range",
  size = "medium",
  sx = {},
  emptyTitle,
  emptyDescription,
}) {
  const { formatMessage } = useIntl();
  const wordingMap = {
    later: formatMessage({ id: "emptyStatus.chart.checkLater.description" }),
    range: formatMessage({ id: "emptyStatus.chart.description" }),
    noData: formatMessage({ id: "emptyState.barChart.title" }),
  };

  const sizeMap = {
    small: "186px",
    medium: "302px",
    large: "none",
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        ...sx,
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          maxWidth: sizeMap[size],
          margin: "0 auto",
          fontSize: "14px",
        }}
      >
        <img
          width={60}
          height={60}
          src={require(`assets/img/emptyState/${icon}.svg`)}
        />
        <Box mt="12px" fontWeight={700} color="#555">
          {emptyTitle ?? formatMessage({ id: "emptyStatus.chart.title" })}
        </Box>
        <Box mt="8px" color="#777">
          {emptyDescription ?? wordingMap[wording]}
        </Box>
      </Box>
    </Box>
  );
}
//
